import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <Link to="/">
            <Button variant="ghost">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back
            </Button>
          </Link>
        </div>
      </header>
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-slate-900 mb-8" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Terms of Service
        </h1>
        
        <div className="prose prose-slate max-w-none">
          <p className="text-sm text-slate-500 mb-8">Last updated: January 2025</p>
          
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using CareerBoost, BizPlanAI, CreditBoost, or any related services 
            (collectively, the "Services") owned and operated by Robert Elder III ("Company," "we," "us," or "our"), 
            you agree to be bound by these Terms of Service.
          </p>

          <h2>2. Intellectual Property Rights</h2>
          <p>
            <strong>All content, features, and functionality of the Services are owned by Robert Elder III 
            and are protected by United States and international copyright, trademark, patent, trade secret, 
            and other intellectual property laws.</strong>
          </p>
          <p>
            You may not copy, modify, distribute, sell, or lease any part of our Services, nor may you 
            reverse engineer or attempt to extract the source code of the software, unless laws prohibit 
            these restrictions or you have our written permission.
          </p>
          <p>
            The trademarks, service marks, and logos ("Marks") displayed on the Services are the property 
            of Robert Elder III. You are not permitted to use these Marks without prior written consent.
          </p>

          <h2>3. Prohibited Uses</h2>
          <p>You agree NOT to:</p>
          <ul>
            <li>Copy, reproduce, or clone the Services or any part thereof</li>
            <li>Reverse engineer, decompile, or disassemble the software</li>
            <li>Create derivative works based on the Services</li>
            <li>Scrape, data mine, or extract data from the Services</li>
            <li>Use the Services to build a competitive product</li>
            <li>Sublicense, sell, or transfer access to the Services</li>
            <li>Remove any copyright or proprietary notices</li>
          </ul>

          <h2>4. User Accounts</h2>
          <p>
            You are responsible for maintaining the confidentiality of your account credentials and for 
            all activities that occur under your account. You agree to notify us immediately of any 
            unauthorized use of your account.
          </p>

          <h2>5. Payment Terms</h2>
          <p>
            Certain features of the Services require payment. All payments are processed securely through 
            Stripe. Prices are in USD and are subject to change. Refunds are available within 30 days of 
            purchase if you are not satisfied with the Services.
          </p>

          <h2>6. Disclaimer of Warranties</h2>
          <p>
            THE SERVICES ARE PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND. We do not guarantee that:
          </p>
          <ul>
            <li>AI-generated content will be error-free or achieve specific results</li>
            <li>Credit improvement plans will result in specific score increases</li>
            <li>Business plans will secure funding or loans</li>
            <li>Resume optimization will guarantee job offers</li>
          </ul>
          
          <div className="my-6 p-4 bg-amber-50 border border-amber-200 rounded-lg">
            <p className="font-semibold text-amber-900">
              Important Disclaimer: Assistance, Not Guarantees
            </p>
            <p className="text-amber-800 mt-2">
              Uplift and its products (CareerBoost, BizPlanAI, CreditBoost) are designed to 
              <strong> provide assistance and guidance only</strong>. We do NOT guarantee any specific outcomes, 
              including but not limited to: job placement, loan approval, credit score improvements, or business success.
              Our AI tools are meant to help and support your efforts, but results depend on many factors beyond our control.
              Use our services as a helpful resource, not as a guarantee of success.
            </p>
          </div>

          <h2>7. Limitation of Liability</h2>
          <p>
            IN NO EVENT SHALL ROBERT ELDER III BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, 
            CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF YOUR USE OF THE SERVICES.
          </p>

          <h2>8. DMCA and Copyright Infringement</h2>
          <p>
            We respect intellectual property rights. If you believe your work has been copied in a way 
            that constitutes infringement, please contact us with the required information under the DMCA.
          </p>

          <h2>9. Governing Law</h2>
          <p>
            These Terms shall be governed by the laws of the United States. Any disputes shall be 
            resolved in the courts of [Your State].
          </p>

          <h2>10. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. Continued use of the Services 
            constitutes acceptance of modified Terms.
          </p>

          <h2>11. Contact Information</h2>
          <p>
            For questions about these Terms, please contact:<br />
            Robert Elder III<br />
            Founder & CEO<br />
            Email: <a href="mailto:support@uplifturlife.info" className="text-indigo-600 hover:underline">support@uplifturlife.info</a><br />
            Or: <a href="mailto:elderservicesunlimitedllc@gmail.com" className="text-indigo-600 hover:underline">elderservicesunlimitedllc@gmail.com</a>
          </p>

          <div className="mt-12 p-6 bg-slate-100 rounded-xl">
            <p className="font-semibold text-slate-900">
              © 2024-2025 Robert Elder III. All Rights Reserved.
            </p>
            <p className="text-sm text-slate-600 mt-2">
              Uplift™, CareerBoost™, BizPlanAI™, and CreditBoost™ are trademarks of Robert Elder III.
              Unauthorized reproduction, distribution, or use is strictly prohibited and may 
              result in civil and criminal penalties.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
